<template>
<div>
  <vue-headful :title="site_title" />
  <Header />
  <template v-if="this.response">
    <div style="display: flex; justify-content: center;">
      <table>
        <tr v-for="emoji in this.response.emojis">
          <td style="text-align: center; width: 50px;">{{emoji.typed}} </td>
          <th style="width: 100px;">{{emoji.image}} </th>
          <td style="text-align: center; width: 50px;"><img :src="'html/emoticons/' + (emoji.image)" /></td>
        </tr>
      </table>
    </div>
    <FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="this.response.queries" />
  </template>
</div>
</template>

<script>
import Header from './Header'
import FooterPermanent from './FooterPermanent'

export default {
  components: {
    Header,
    FooterPermanent
  },
  data: function() {
    return {
      response: null,
      footerReady: false
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let response = await fetch(this.getNodePath() + 'debug/emoticons/');
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    this.footerReady = true;
    console.timeEnd("PageLoadTime");
  }
}
</script>

<style lang="scss">
</style>
